import { defaultLinkStyle } from "components/ui/link";
import React from "react";
import { Link } from "react-router-dom";

export const AgencySettingsLink: React.FC<{
    canManageAgencySettings: boolean;
}> = props => {
    if (props.canManageAgencySettings) {
        return (
            <Link to="/settings/agency/referrals" className={defaultLinkStyle}>
                agency settings
            </Link>
        );
    }
    return <>agency settings</>;
};
